// extracted by mini-css-extract-plugin
export default {"root":"BillingNotesGroupContainer_root__6P9Gg","tableWrap":"BillingNotesGroupContainer_tableWrap__x0pLV"};